import React, { useState } from "react";
import AppLayout from "../components/AppLayout";
import Categories from "../components/Categories";
import ProductCatalog from "../components/ProductCatalog";
import { useQuote } from "../context/QuoteContext";

const CatalogPage = () => {
    const [selectedCategory, setSelectedCategory] = useState("all");
    const { addToQuote, selectedIds } = useQuote();

    const handleSelectCategory = (id) => {
        setSelectedCategory(id);
        setTimeout(() => {
            document.getElementById("catalogo")?.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 50);
    };

    return (
        <AppLayout pageTitle="Catalogo" showBack backTo="/">
            <Categories onSelect={handleSelectCategory} />
            <div className="max-w-[1400px] mx-auto px-5 sm:px-8 lg:px-14" data-testid="catalog-divider">
                <div className="border-t-2 border-nsp-green/15 relative">
                    <span className="absolute left-0 -top-[3px] w-24 h-1 rounded-full bg-nsp-yellow" />
                </div>
            </div>
            <ProductCatalog
                selectedCategory={selectedCategory}
                onCategoryChange={setSelectedCategory}
                onAddToQuote={addToQuote}
                selectedIds={selectedIds}
            />
        </AppLayout>
    );
};

export default CatalogPage;
